export function formatMoney(s: string | number) {
  return parseFloat(s.toString()).toFixed(2)
}

export function formatMoneyWithCurrency(s: string | number) {
  return `£${formatMoney(s)}`
}
